import React, { useState } from "react";
import { Link, Redirect, Route, Switch, useHistory } from "react-router-dom";
import { AppVariant, getAppDetails } from "src/config/appVariants";
import { BODY_AND_MIND, getLowestPermissionRoute } from "src/constants/permissions";
import BodyAndMind, { DefaultBodyAndMindFeatureName } from "src/scenes/BodyAndMind";
import BodyAndMindViewer from "src/scenes/BodyAndMind/Viewer/BodyAndMindViewer";
import SurveyViewer from "src/scenes/Survey/Viewer/SurveyViewer";
import QuotesViewer, { DefaultQuotesViewerName } from "src/scenes/MyQuotes/Viewer/QuotesViewer";
import NoticeboardViewer from "src/scenes/Noticeboard/Viewer/NoticeboardViewer";
import { CheckedInUser, checkedInTheme } from "./checkedInUser";
import {
    CheckedInAction, CheckedInBrand, CheckedInSiteHeader, CheckedInSiteMain, CheckedInSiteNav, CheckedInSiteRoot
} from "./CheckedInSiteStyles";

export default function CheckedInSite({ user, logout }: { user: CheckedInUser; logout: () => Promise<void> }): React.ReactElement {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    const history = useHistory();
    const app = getAppDetails(AppVariant.CHECKED_IN);
    const name: string = user.customBodyAndMindName || DefaultBodyAndMindFeatureName;
    const defaultRoute: string = getLowestPermissionRoute(user.permissions, user.appVariant, user.isClient);
    return <CheckedInSiteRoot style={checkedInTheme(user)}>
        <CheckedInSiteHeader>
            <CheckedInBrand to={defaultRoute} aria-label="Checked In home" onClick={() => setMenuOpen(false)} />
            <CheckedInAction type="button" $outline aria-expanded={menuOpen} aria-controls="checked-in-menu"
                onClick={() => setMenuOpen(value => !value)}>{menuOpen ? "Close menu" : "Menu"}</CheckedInAction>
        </CheckedInSiteHeader>
        <CheckedInSiteNav $open={menuOpen} id="checked-in-menu" aria-label="Main menu">
            <Link to="/body-and-mind" onClick={() => setMenuOpen(false)}>{name}</Link>
            <Link to="/survey" onClick={() => setMenuOpen(false)}>Surveys</Link>
            <Link to="/myquotes" onClick={() => setMenuOpen(false)}>{user.customMyQuotesName || DefaultQuotesViewerName}</Link>
            <Link to="/noticeboard" onClick={() => setMenuOpen(false)}>Noticeboard</Link>
            <CheckedInAction type="button" $outline onClick={() => {
                history.replace("/checkedIn/landing");
                void logout();
            }}>Log Out</CheckedInAction>
            <a href={app.termsUrl} target="_blank" rel="noreferrer">Terms &amp; Conditions</a>
            <a href={app.privacyUrl} target="_blank" rel="noreferrer">Privacy Policy</a>
        </CheckedInSiteNav>
        <CheckedInSiteMain>
            <Switch>
                <Route path="/noticeboard"><NoticeboardViewer user={user} /></Route>
                <Route path="/myquotes"><QuotesViewer user={user} /></Route>
                <Route path="/survey"><SurveyViewer user={user} /></Route>
                <Route path="/body-and-mind">
                    {user.permissions.includes(BODY_AND_MIND) ? <BodyAndMind user={user} /> : <BodyAndMindViewer user={user} />}
                </Route>
                <Route path="*"><Redirect to={defaultRoute} /></Route>
            </Switch>
        </CheckedInSiteMain>
    </CheckedInSiteRoot>;
}
